import { useMemo, createContext } from 'react';
import { ColumnContainer, GridContainer } from './styled';
/* Context */
const GridContext = createContext({});
/* Column */
export function Column(props) {
    const { children, width = '100%', className } = props;
    return (<GridContext.Consumer>
      {({ spacing, horizontal, vertical }) => (<ColumnContainer className={className} $spacing={spacing} $horizontal={horizontal} $vertical={vertical} style={{ width }}>
          {children}
        </ColumnContainer>)}
    </GridContext.Consumer>);
}
/* Grid */
export function Grid(props) {
    const { children, spacing = 6, directions = 'horizontal vertical', className } = props;
    const [horizontal, vertical] = useMemo(() => {
        const parts = directions.split(' ');
        return [parts.includes('horizontal'), parts.includes('vertical')];
    }, [directions]);
    return (<GridContainer $spacing={spacing} $horizontal={horizontal} $vertical={vertical} className={className}>
      <GridContext.Provider value={{ spacing, horizontal, vertical }}>{children}</GridContext.Provider>
    </GridContainer>);
}
